package com.milta.feature.profile.domain.usecase

import com.milta.feature.profile.domain.repository.ProfileRepository

class RequestPhoneChangeUseCase(private val repository: ProfileRepository) {
    suspend operator fun invoke(phoneNumber: String): Result<Unit> {
        require(phoneNumber.isNotBlank()) { "phone_required" }
        return repository.requestPhoneChange(phoneNumber)
    }
}
